export class RawAudioManager {
  private _rawAudioRecorder = (window as any).RawAudioRecorder;

  start(onNewData: (chunks: number[]) => void) {
    this._rawAudioRecorder.startListening(
      () => {
        console.log("RawAudioRecorder onStart callback");
      },
      onNewData,
      () => {
        console.log("RawAudioRecorder onStop callback");
      },

      () => {
        console.log("onError callback");
      }
    );
  }

  stop() {
    this._rawAudioRecorder.stopListening();
  }
}
